import "./install-gsap.js";
import GLightbox from 'glightbox'
import ScrollMagic from "scrollmagic";
import ScrollMagicGsap from "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import ScrollMagicDebug from "scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min";


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        gsap.from('body', {duration: 1, autoAlpha: 0});

    }, 200);
    gsap.from('.scroll-btn > img', {duration: 2, y: '-=50', autoAlpha: 0, repeat: -1, yoyo: true});
    const controller = new ScrollMagic.Controller();
    const tlShowLocations = gsap.timeline();
    const tlShowAbout = gsap.timeline();
    const tlShowGallery = gsap.timeline();

    const tlShowHighlights = gsap.timeline();

    tlShowLocations
        .from(".cta > *", {autoAlpha: 0, y: '-=50', stagger: 0.3, ease: 'slow(0.6,1.5)'})
        .from(".col-3 > *", {autoAlpha: 0, y: '-=50', stagger: 0.3, ease: 'slow(0.6,1.5)'}, '<0.6')
        .from(".col-2 > *", {autoAlpha: 0, y: '-=50', stagger: 0.3, ease: 'slow(0.6,1.5)'})
    ;

    tlShowAbout
        .from('.title--huge', {duration: 1.2, autoAlpha: 0, y: '-=50', ease: 'slow(0.6,1.5)'})
        .from('.copy-wrapper > *', {duration: 1, autoAlpha: 0, stagger: 0.5, y: '-=10', ease: 'slow(0.6,1.5)'})
        .from('.reviews-wrapper > *', {duration: 1, autoAlpha: 0, stagger: 0.5, y: '-=10', ease: 'slow(0.6,1.5)'})

    ;
    tlShowGallery
        .from('#gallery', {duration: 2, autoAlpha: 0, y: '-=50', ease: 'slow(0.6,1.5)'})

    ;

    tlShowHighlights
        .from('.highlights > *', {stagger: 0.3, autoAlpha: 0, y: '-=50', ease: 'slow(0.6,1.5)'})

    ;

    const sceneShowLocations = new ScrollMagic.Scene({
        triggerElement: "#book",
        triggerHook: 0.7
    })
    // .addIndicators({
    //     colorTrigger: "white",
    //     colorStart: "white",
    //     colorEnd: "white",
    //     indent: 5
    // })
        .setTween(tlShowLocations)
        .addTo(controller);

    const sceneShowAbout = new ScrollMagic.Scene({
        triggerElement: "#about",
        triggerHook: 0.7
    })
    // .addIndicators({
    //     colorTrigger: "white",
    //     colorStart: "white",
    //     colorEnd: "white",
    //     indent: 10
    // })
        .setTween(tlShowAbout)
        .addTo(controller);

    const scetlShowGallery = new ScrollMagic.Scene({
        triggerElement: "#gallery",
        triggerHook: 0.7
    })
    // .addIndicators({
    //     colorTrigger: "white",
    //     colorStart: "white",
    //     colorEnd: "white",
    //     indent: 10
    // })
        .setTween(tlShowGallery)
        .addTo(controller);

    const scetlShowHighlights = new ScrollMagic.Scene({
        triggerElement: ".highlights",
        triggerHook: 0.7
    })
    // .addIndicators({
    //     colorTrigger: "white",
    //     colorStart: "white",
    //     colorEnd: "white",
    //     indent: 10
    // })
        .setTween(tlShowHighlights)
        .addTo(controller);


    const homeScroll = document.querySelector('.home-scroll');
    const bookScroll = document.querySelector('.book-scroll');
    const aboutScroll = document.querySelector('.about-scroll');
    const galleryScroll = document.querySelector('.gallery-scroll');
    const signScroll = document.querySelector('.sign-scroll');
    const signScrollBtn = document.querySelector('.btn-signup');

    const homeScrollTo = document.querySelector('#home');
    const bookScrollTo = document.querySelector('#book');
    const aboutScrollTo = document.querySelector('#about');
    const galleryScrollTo = document.querySelector('#gallery');
    const signScrollTo = document.querySelector('#mc_embed_signup');
    const headerBar = document.querySelector('.header-bar');

    let headerBarHeight = headerBar.clientHeight + 40;


    const scrollArray = [homeScroll, bookScroll, aboutScroll, galleryScroll
    ];
    const scrollArrrayTo = [homeScrollTo, bookScrollTo, aboutScrollTo, galleryScrollTo];

    homeScroll.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: homeScrollTo});
    });

    signScroll.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: {y: signScrollTo, offsetY: headerBarHeight}});
    });

    signScrollBtn.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: {y: signScrollTo, offsetY: headerBarHeight}});
    });

    bookScroll.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: {y: bookScrollTo, offsetY: headerBarHeight}});
    });

    aboutScroll.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: {y: aboutScrollTo, offsetY: headerBarHeight}});
    });
    galleryScroll.addEventListener('click', (e) => {
        e.preventDefault();
        gsap.to(window, {duration: 2, scrollTo: {y: galleryScrollTo, offsetY: headerBarHeight}});
    });


// window.onload = function () {
//     // Intensify all images with the 'intense' classname.
//     var elements = document.querySelectorAll('.zoom');
//     Intense(elements);
// }
    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        onOpen: () => {
            console.log('Lightbox opened')
        },
        beforeSlideLoad: (slide, data) => {
            // Need to execute a script in the slide?
            // You can do that here...
        }
    });

});
